<template>
  <AkAlert :type="AlertType.Info">
    <AkParagraph>
      {{ $t('retailer.order.thankYouValidated.alert.description') }}
    </AkParagraph>
  </AkAlert>
</template>

<script setup lang="ts">
import { AkParagraph, AlertType } from '@ankorstore/design-system';

defineOptions({
  name: 'AlertThankYouValidated',
});
</script>
